<app-filter-panel [quickSearchFilter]="filters.name" quickSearchPlaceholder="Nombre" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
    <span class="w-full input-field p-input-icon-right">
        <input pInputText placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer"
            (click)="filters.name.value = null; search()"></i>
    </span>
</div>
-->

<p-table #grid [value]="casesTypes" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>
            
            <th width="200" *ngFor="let caseMode of caseModes">{{caseMode.name}}</th>
            <th width="100"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-caseType let-columns="columns">
        <tr class="fila-clicable" (dblclick)="edit(caseType)">
            <td>{{caseType.name}}</td>
            <td *ngFor="let caseMode of caseModes">
                <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': hasCaseMode(caseType, caseMode.id), 'text-red-500 pi-times-circle': !hasCaseMode(caseType, caseMode.id) }"></i>
            </td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="delete(caseType)" [rounded]="true" [text]="false"
                        severity="danger" styleClass="accion-fila"><i class="pi pi-trash"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>